import { useOrganization } from '@apis/rendall/queries/use-organization';
import { useOrganizationContext } from '@packages/legacy/organization-context';

export const useRendallOrganization = () => {
  const { selectedOrganization } = useOrganizationContext();

  const { data, isPending } = useOrganization(
    selectedOrganization.id,
    selectedOrganization.rendallURL,
  );

  return {
    organizationId: selectedOrganization.id,
    currentOrganization: data,
    isPending,
  };
};
